/*eslint-disable*/
import actions from './actions';

const initialState = {
  orders: [],
  columnOptions: {},
  pagination: {
    currentPage: 1,
    totalPages: 0,
    totalRecords: 0,
    limit: 10,
  },
  loading: false,
  error: null,
};

const {
  ORDER_FETCH_BEGIN,
  ORDER_FETCH_SUCCESS,
  ORDER_FETCH_ERR,
  ORDER_UPDATE_BEGIN,
  ORDER_UPDATE_SUCCESS,
  ORDER_UPDATE_ERR,
} = actions;

const productOrderReducer = (state = initialState, action) => {
  const { type, data, meta, err } = action;

  switch (type) {
    case ORDER_FETCH_BEGIN:
    case ORDER_UPDATE_BEGIN:
      return {
        ...state,
        loading: type === ORDER_FETCH_BEGIN,
        error: null,
      };

    case ORDER_FETCH_SUCCESS:
      return {
        ...state,
        orders: data,
        columnOptions: meta?.columnOptions || {},
        pagination: meta ? meta.pagination : state.pagination,
        loading: false,
      };

    case ORDER_UPDATE_SUCCESS:
      return {
        ...state,
        orders: state.orders.map((order) => (order._id === data._id ? data : order)),
        loading: false,
      };

    case ORDER_FETCH_ERR:
    case ORDER_UPDATE_ERR:
      return {
        ...state,
        loading: false,
        error: err,
      };

    default:
      return state;
  }
};

export { productOrderReducer };

